import React, { useState } from 'react';
import ToolLayout from '../../components/ToolLayout';
import { Textarea } from '../../components/ui/textarea';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import { useToast } from '../../hooks/use-toast';
import { Copy, Link } from 'lucide-react';

const URLEncoderPage = () => {
  const { toast } = useToast();
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');

  const encode = () => {
    const encoded = encodeURIComponent(input);
    setOutput(encoded);
  };

  const decode = () => {
    try {
      const decoded = decodeURIComponent(input);
      setOutput(decoded);
    } catch (err) {
      toast({
        title: 'Error',
        description: 'Invalid URL encoded string',
        variant: 'destructive'
      });
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(output);
    toast({
      title: 'Copied!',
      description: 'Output copied to clipboard',
    });
  };

  const clear = () => {
    setInput('');
    setOutput('');
  };

  return (
    <ToolLayout
      title="URL Encoder/Decoder"
      description="Encode or decode URLs for safe transmission. Essential for working with query parameters and special characters in URLs."
      icon={Link}
    >
      <div className="space-y-6">
        <div>
          <Label htmlFor="input">Input</Label>
          <Textarea
            id="input"
            placeholder="Enter URL to encode or encoded URL to decode..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            rows={6}
            className="font-mono text-sm"
          />
        </div>

        <div className="flex flex-wrap gap-3">
          <Button onClick={encode}>Encode URL</Button>
          <Button onClick={decode} variant="secondary">Decode URL</Button>
          <Button onClick={clear} variant="outline">Clear</Button>
        </div>

        {output && (
          <div>
            <div className="flex items-center justify-between mb-2">
              <Label>Output</Label>
              <Button onClick={copyToClipboard} variant="ghost" size="sm">
                <Copy className="w-4 h-4 mr-2" />
                Copy
              </Button>
            </div>
            <Textarea
              value={output}
              readOnly
              rows={6}
              className="font-mono text-sm bg-gray-50 dark:bg-gray-900"
            />
          </div>
        )}
      </div>
    </ToolLayout>
  );
};

export default URLEncoderPage;